import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Table, Button } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #FFFFFF;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
  main {
    display:flex;
    justify-content: flex-start;
    align-items:center;
    flex-direction: row;
  }
  button {
    padding: 10px 20px;
    align-self: center;
    justify-self:center;
    margin-left: 50px;
    border: none;
    border-radius: 10px;
    color:#fff;
    font-weight:bold;
    &:hover{
      cursor: pointer;
      background-color: #ccc;
      color: #222;
    }
  }
`;

export const Title = styled.h1`
  width: 100%;
  margin:0px 0px 15px 0px;
  padding: 0px;

  color:#000000;

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;

  border-bottom: 1px solid rgba(34,36,38,.15);

  display: inline-block;
`;
export const Input = styled.input`
  height:35px;
  width: 100%;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;
export const Select = styled.select`
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;
export const ContentExternal = styled.div`
  display: ${props => props.trails ? 'flex' : 'none'};
  align-items:center;
  justify-content: center;
  flex-direction: column;
  div {
    justify-self: flex-end;
    margin-top:20px;
    padding: 20px 0px 40px 0px;
  }
  button {
    padding: 10px 20px;
    align-self: center;
    justify-self:center;
    margin-left: 50px;
    border: none;
    border-radius: 10px;
    color:#fff;
    font-weight:bold;
    &:hover{
      cursor: pointer;
      background-color: #ccc;
      color: #222;
    }
  }
`;
export const ContentCheck = styled.div`
  display: grid;
  align-items:center;
  justify-content: center;
  grid-template-columns: 1fr 1fr 1fr;
  border: 1px solid #222;
  margin-top: 20px;
  section {
    padding: 10px;
    display:flex;
    align-items:center;
    justify-content: flex-start;
    margin-top: 10px;

    label {
      margin-left: 5px;
    }
  }
`;